module.exports = __webpack_public_path__ + "static/media/owl-refuse-proposal.83752fbb.svg";